import React from 'react';
import ReactApexChart from 'react-apexcharts';

export default function Chart(props) {
  return (
    <>
      <div id='chart'>
        <ReactApexChart
          options={props.options}
          series={props.series}
          type='area'
          height={290}
        />
      </div>
    </>
  );
}
